import React, { useEffect, useState } from 'react';
import { Skeleton } from 'antd';
import { apiGetDevicesInformation } from '@services/ManageDevices/DeviceServices';
import { showError } from '@components/notification';
import DonutStat from './DonutStat';
import { formatCurrency } from '@utils/utils';
import { PALETTE } from '../dashboardTheme';

const DeviceStatusCharts = ({ compact = false }) => {
  const [loading, setLoading] = useState(false);
  const [countDetail, setCountDetail] = useState(null);

  const handleChartClick = (status) => {
    // Scroll to list component
    const listElement = document.getElementById('device-list-table');
    if (listElement) {
      listElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Set filter status using event
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('filterDeviceStatus', { detail: { status } }));
    }, 500);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await apiGetDevicesInformation({
        page: 1,
        size: 10
      });
      setCountDetail(res.data?.meta?.countDetail);
    } catch (error) {
      console.error('Error fetching device statistics:', error);
      showError('Không thể tải thống kê thiết bị');
      setCountDetail(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return <Skeleton active paragraph={{ rows: 6 }} />;
  }

  const online = Number(countDetail?.total_online || 0);
  const offline = Number(countDetail?.total_offline || 0);
  const strong = Number(countDetail?.rsrp_strong || 0);
  const rsrpTotal =
    strong + Number(countDetail?.rsrp_normal || 0) + Number(countDetail?.rsrp_low || 0);
  const strongPct = rsrpTotal ? Math.round((strong / rsrpTotal) * 100) : 0;

  return (
    <>
      {!compact && (
        <p className="panel-note">
          Phân tích chất lượng <b>{formatCurrency(online + offline, 0)}</b> đồng hồ đang kết nối
          mạng NB-IoT & 4G · nhấn vào biểu đồ để lọc danh sách
        </p>
      )}
      <div className="donut-pair">
        <DonutStat
          title="Kết nối mạng"
          compact={compact}
          unit="thiết bị"
          items={[
            {
              label: 'Online',
              value: countDetail?.total_online,
              color: PALETTE.success,
              status: 'online'
            },
            {
              label: 'Offline',
              value: countDetail?.total_offline,
              color: PALETTE.danger,
              status: 'offline'
            }
          ]}
          onSelect={(item) => handleChartClick(item.status)}
        />
        <DonutStat
          title="Chất lượng sóng NB-IoT"
          compact={compact}
          unit="thiết bị"
          centerValue={`${strongPct}%`}
          centerLabel="Sóng tốt"
          items={[
            {
              label: 'Tốt (≥ -100 dBm)',
              value: countDetail?.rsrp_strong,
              color: PALETTE.sky,
              status: 'RSRP_STRONG'
            },
            {
              label: 'TB (-110 ~ -100)',
              value: countDetail?.rsrp_normal,
              color: PALETTE.warning,
              status: 'RSRP_NORMAL'
            },
            {
              label: 'Yếu (< -110 dBm)',
              value: countDetail?.rsrp_low,
              color: PALETTE.danger,
              status: 'RSRP_LOW'
            }
          ]}
          onSelect={(item) => handleChartClick(item.status)}
        />
      </div>
    </>
  );
};

export default DeviceStatusCharts;
